import { Viewer } from '@orcar/common-d2c';
import styled from 'styled-components';
import { SUPERCAR_RENTAL_AGE_NOTICE } from '@/constants/rental-rules';
import { SectionTitle } from './commonStyles';

type RentPolicyProps = {
  name: string;
  rentPolicies: string;
  isMobile: boolean;
  hasPadding?: boolean;
  gap?: number;
};

const RentPolicy = ({
  name,
  rentPolicies,
  isMobile,
  hasPadding,
  gap,
}: RentPolicyProps) => {
  return (
    <ContentWrapper hasPadding={hasPadding} gap={gap}>
      <SectionTitle isMobile={isMobile}>{name} 대여 규정</SectionTitle>
      <ViewerWrapper>
        <Viewer content={rentPolicies} style={{ lineHeight: '27px' }} />
        {/* DB 대여규정 본문에 없는 차급별 추가 대여 자격은 프론트에서 고정 노출한다. */}
        <NoticeText>{SUPERCAR_RENTAL_AGE_NOTICE}</NoticeText>
      </ViewerWrapper>
    </ContentWrapper>
  );
};

export default RentPolicy;

const ContentWrapper = styled.div<{
  hasPadding?: boolean;
  isMobile?: boolean;
  gap?: number;
}>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ? `${gap}px` : '0px')};
  width: 100%;
  padding: ${({ hasPadding }) => hasPadding && '30px 0'};
  scroll-margin: ${({ isMobile }) => (isMobile ? '110px' : '150px')};
`;

const NoticeText = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 27px;
  color: ${({ theme }) => theme.COLOR.RED};
  white-space: pre-wrap;
`;

const ViewerWrapper = styled.div`
  padding: 4px 0;
`;
